import Swiper from 'swiper/bundle';

export default function  initializeGalleryText(){
    if(document.querySelector('.block-gallery-text__swiper')) {
        let swiper = new Swiper( ".block-gallery-text__swiper", {
            loop: true,
            grabCursor: true,
            speed: 1000,
            slidesPerView: 'auto',
            spaceBetween: 12,
            autoplay: {
                delay: 5000,
            },
            // navigation: {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev',
            // },
        });
    }
}